import React from 'react';

const founders = [
  {
    name: 'Francesco Sozzi',
    nickname: '"Cecco"',
    role: 'Maieuta — Coaching & Formazione',
    photo: '/francesco_sozzi.png',
    bio: 'Percorsi di crescita, formazione esperienziale, maieutica applicata. Il sapere è già dentro di te.',
    links: [],
    color: '#FF6B6B',
    placeholder: true,
  },
  {
    name: 'Riccardo Rossi',
    role: 'Google Trusted & AI Expert',
    photo: '/riccardo_rossi.jpg',
    bio: 'Street View Certified dal 2016. 7.000+ foto, 52M views. Virtual Tour, consulenza, formazione detraibile.',
    badge: 'Google Trusted',
    links: [
      { label: 'schedabusiness.com', url: 'https://schedabusiness.com/' },
      { label: 'Email', url: 'mailto:riccardorossi1984@gmail.com' },
    ],
    color: '#FFD700',
    stats: ['51 recensioni 5 stelle', '7.000+ foto', '52M views'],
  },
  {
    name: 'Marco Bruni',
    role: 'Psicologo & Psicoterapeuta',
    photo: '/marco_bruni.jpeg',
    bio: 'Supporto emotivo, crescita personale, superamento traumi. Sportello Mentor per tutti gli iscritti.',
    links: [
      { label: 'MioDottore', url: 'https://www.miodottore.it/marco-bruni-2/psicoterapeuta-psicologo-psicologo-clinico/colle-di-val-d-elsa' },
      { label: 'Email', url: 'mailto:marco.bruni7@gmail.com' },
    ],
    color: '#10B981',
  },
];

const FoundersSection = () => {
  return (
    <section data-testid="founders-section" className="py-16 px-4">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="text-center mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#00FF41] mb-3">
            &lt;/ MISSIONE &gt;
          </p>
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">
            I Fondatori
          </h2>
          <p className="text-white font-bold text-sm max-w-lg mx-auto">
            I primi 3 di molti altri. Nessun leader. Nessun numero uno. Un team.
          </p>
        </div>

        {/* 3 Founders */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {founders.map((f, i) => (
            <div key={i} data-testid={`founder-${i}`}
              className="border rounded-2xl p-6 text-center transition-all duration-300 hover:scale-[1.02]"
              style={{ borderColor: `${f.color}33`, background: '#0A0A0A' }}
            >
              {/* Photo */}
              <div className="relative mx-auto mb-4" style={{ width: '120px', height: '120px' }}>
                <img
                  src={f.photo}
                  alt={f.name}
                  className="w-full h-full object-cover rounded-full"
                  style={{ border: `3px solid ${f.color}` }}
                />
                {f.badge && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[8px] font-black px-2 py-0.5 rounded-full whitespace-nowrap"
                    style={{ background: f.color, color: '#000' }}>
                    {f.badge}
                  </span>
                )}
              </div>

              {/* Name & Role */}
              <h3 className="text-white font-black text-lg mb-0.5">
                {f.name} {f.nickname && <span className="text-white/60 font-normal text-sm">{f.nickname}</span>}
              </h3>
              <p className="font-mono text-xs font-bold mb-3" style={{ color: f.color }}>
                {f.role}
              </p>

              {/* Bio */}
              <p className="text-white font-bold text-xs leading-relaxed mb-4" style={{ minHeight: '48px' }}>
                {f.bio}
              </p>

              {/* Stats */}
              {f.stats && (
                <div className="flex justify-center gap-2 flex-wrap mb-4">
                  {f.stats.map((s, j) => (
                    <span key={j} className="text-[9px] font-mono font-bold px-2 py-0.5 rounded-full border"
                      style={{ borderColor: `${f.color}44`, color: f.color }}>
                      {s}
                    </span>
                  ))}
                </div>
              )}

              {/* Placeholder note */}
              {f.placeholder && (
                <p className="text-white/30 text-[10px] font-mono italic mb-4">Bio completa in arrivo...</p>
              )}

              {/* Links */}
              {f.links.length > 0 && (
                <div className="flex justify-center gap-2 flex-wrap">
                  {f.links.map((l, j) => (
                    <a key={j} href={l.url} target="_blank" rel="noopener noreferrer"
                      className="font-mono text-[10px] font-bold px-3 py-1.5 border rounded-full transition-all hover:scale-105"
                      style={{ borderColor: f.color, color: f.color }}
                    >
                      {l.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Vasche comunicanti */}
        <div className="max-w-2xl mx-auto">
          <div className="relative" style={{ height: '120px' }}>
            {/* SVG Vasche */}
            <svg viewBox="0 0 600 120" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
              {/* 3 vasche */}
              <rect x="20" y="30" width="160" height="80" rx="8" fill="none" stroke="#FF6B6B" strokeWidth="2" opacity="0.6" />
              <rect x="220" y="30" width="160" height="80" rx="8" fill="none" stroke="#FFD700" strokeWidth="2" opacity="0.6" />
              <rect x="420" y="30" width="160" height="80" rx="8" fill="none" stroke="#10B981" strokeWidth="2" opacity="0.6" />

              {/* Tubi comunicanti */}
              <line x1="180" y1="70" x2="220" y2="70" stroke="#00FF41" strokeWidth="2" strokeDasharray="4 4" opacity="0.5" />
              <line x1="380" y1="70" x2="420" y2="70" stroke="#00FF41" strokeWidth="2" strokeDasharray="4 4" opacity="0.5" />

              {/* Acqua — stesso livello */}
              <rect x="24" y="55" width="152" height="51" rx="4" fill="#FF6B6B" opacity="0.15">
                <animate attributeName="y" values="55;52;55" dur="3s" repeatCount="indefinite" />
                <animate attributeName="height" values="51;54;51" dur="3s" repeatCount="indefinite" />
              </rect>
              <rect x="224" y="55" width="152" height="51" rx="4" fill="#FFD700" opacity="0.15">
                <animate attributeName="y" values="55;52;55" dur="3s" repeatCount="indefinite" />
                <animate attributeName="height" values="51;54;51" dur="3s" repeatCount="indefinite" />
              </rect>
              <rect x="424" y="55" width="152" height="51" rx="4" fill="#10B981" opacity="0.15">
                <animate attributeName="y" values="55;52;55" dur="3s" repeatCount="indefinite" />
                <animate attributeName="height" values="51;54;51" dur="3s" repeatCount="indefinite" />
              </rect>

              {/* Nomi nelle vasche */}
              <text x="100" y="82" textAnchor="middle" fill="#FF6B6B" fontSize="11" fontWeight="900" fontFamily="monospace">Cecco</text>
              <text x="300" y="82" textAnchor="middle" fill="#FFD700" fontSize="11" fontWeight="900" fontFamily="monospace">Riccardo</text>
              <text x="500" y="82" textAnchor="middle" fill="#10B981" fontSize="11" fontWeight="900" fontFamily="monospace">Marco</text>

              {/* Livello label */}
              <text x="300" y="18" textAnchor="middle" fill="#fff" fontSize="9" fontWeight="700" fontFamily="monospace" opacity="0.6">IL LIVELLO SALE O SCENDE INSIEME A NOI</text>

              {/* Linea livello */}
              <line x1="20" y1="55" x2="580" y2="55" stroke="#00FF41" strokeWidth="1" strokeDasharray="2 6" opacity="0.3">
                <animate attributeName="y1" values="55;52;55" dur="3s" repeatCount="indefinite" />
                <animate attributeName="y2" values="55;52;55" dur="3s" repeatCount="indefinite" />
              </line>
            </svg>
          </div>
          <p className="text-center text-white font-bold text-xs mt-2">
            Vasi comunicanti — Il livello e uguale per tutti. Sempre.
          </p>
        </div>

      </div>
    </section>
  );
};

export default FoundersSection;
